/* Rivet theme JS: mobile nav, variant picker, AJAX cart + drawer, toasts. No dependencies. */
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const money = (cents) => {
    const fmt = window.Rivet && window.Rivet.moneyFormat ? window.Rivet.moneyFormat : '£{{amount}}';
    const amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  };
  const toast = (msg) => {
    let t = $('.toast');
    if (!t) { t = document.createElement('div'); t.className = 'toast'; document.body.appendChild(t); }
    t.textContent = msg; t.dataset.show = 'true';
    clearTimeout(t._h); t._h = setTimeout(() => (t.dataset.show = 'false'), 2200);
  };

  /* mobile nav */
  const mnav = $('.mnav');
  $$('[data-menu-open]').forEach((b) => b.addEventListener('click', () => { mnav.dataset.open = 'true'; }));
  $$('[data-menu-close]').forEach((b) => b.addEventListener('click', () => { mnav.dataset.open = 'false'; }));

  /* cart drawer */
  const drawer = $('#CartDrawer');
  const openDrawer = () => { if (drawer) { drawer.dataset.open = 'true'; document.body.style.overflow = 'hidden'; } };
  const closeDrawer = () => { if (drawer) { drawer.dataset.open = 'false'; document.body.style.overflow = ''; } };
  $$('[data-cart-open]').forEach((b) => b.addEventListener('click', (e) => { if (!drawer) return; e.preventDefault(); refreshDrawer().then(openDrawer); }));
  $$('[data-cart-close]').forEach((b) => b.addEventListener('click', closeDrawer));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeDrawer(); if (mnav) mnav.dataset.open = 'false'; } });

  async function refreshDrawer() {
    if (!drawer) return;
    const res = await fetch('/?section_id=cart-drawer-content');
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('#CartDrawerContent');
    const cur = $('#CartDrawerContent');
    if (fresh && cur) cur.replaceWith(fresh);
    bindLines(drawer);
    const cnt = doc.querySelector('[data-cart-count-src]');
    if (cnt) $$('.cart-count').forEach((c) => (c.textContent = cnt.textContent.trim() === '0' ? '' : cnt.textContent.trim()));
  }

  function bindLines(scope) {
    $$('[data-line-change]', scope).forEach((el) => {
      el.addEventListener('click', async () => {
        const line = el.dataset.lineChange; const q = Number(el.dataset.qty);
        await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line, quantity: q }) });
        if (scope === drawer) refreshDrawer(); else location.reload();
      });
    });
  }
  bindLines(document);

  /* product form */
  $$('form[data-product-form]').forEach((form) => {
    const variants = JSON.parse($('[data-variants]', form).textContent);
    const idInput = $('input[name="id"]', form);
    const priceEl = $('[data-price]');
    const cmpEl = $('[data-compare]');
    const btn = $('[data-add]', form);
    const btnText = $('[data-add-text]', form);
    const fits = $$('[data-fit-for]');
    function current() {
      const opts = $$('fieldset', form).map((f) => { const c = $('input:checked', f); return c ? c.value : null; });
      return variants.find((v) => v.options.every((o, i) => o === opts[i]));
    }
    function sync() {
      const v = current();
      if (!v) { btn.disabled = true; btnText.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (cmpEl) { if (v.compare_at_price && v.compare_at_price > v.price) { cmpEl.textContent = money(v.compare_at_price); cmpEl.hidden = false; } else cmpEl.hidden = true; }
      btn.disabled = !v.available;
      btnText.textContent = v.available ? (btn.dataset.label || 'Add to bag') : 'Sold out';
      fits.forEach((f) => { f.hidden = !(f.dataset.fitFor === v.title || f.dataset.fitFor === v.options[0]); });
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
      const img = $(`[data-variant-image="${v.id}"]`);
      if (img) selectMedia(img.dataset.mediaId);
    }
    $$('input[type=radio]', form).forEach((r) => r.addEventListener('change', sync));
    const qty = $('input[name="quantity"]', form);
    $$('[data-qty]', form).forEach((b) => b.addEventListener('click', () => { qty.value = Math.max(1, Number(qty.value) + Number(b.dataset.qty)); }));
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      btn.disabled = true; const t = btnText.textContent; btnText.textContent = 'Adding…';
      try {
        const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: idInput.value, quantity: Number(qty.value || 1) }) });
        if (!res.ok) throw new Error((await res.json()).description || 'Could not add');
        btnText.textContent = 'Added ✓';
        if (drawer) { await refreshDrawer(); openDrawer(); } else toast('Added to bag');
        setTimeout(() => { btnText.textContent = t; btn.disabled = false; }, 1200);
      } catch (err) { toast(err.message); btnText.textContent = t; btn.disabled = false; }
    });
    sync();
  });

  /* media gallery */
  function selectMedia(id) {
    $$('[data-media]').forEach((m) => (m.hidden = m.dataset.media !== String(id)));
    $$('[data-thumb]').forEach((t) => t.setAttribute('aria-current', t.dataset.thumb === String(id) ? 'true' : 'false'));
  }
  $$('[data-thumb]').forEach((t) => t.addEventListener('click', () => selectMedia(t.dataset.thumb)));

  /* quick add on cards */
  $$('[data-quick-add]').forEach((b) => b.addEventListener('click', async () => {
    const t = b.textContent; b.textContent = 'Adding…'; b.disabled = true;
    try {
      const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: b.dataset.quickAdd, quantity: 1 }) });
      if (!res.ok) throw new Error('Could not add');
      b.textContent = 'Added ✓'; if (drawer) { await refreshDrawer(); openDrawer(); }
    } catch (e) { toast(e.message); }
    setTimeout(() => { b.textContent = t; b.disabled = false; }, 1200);
  }));

  /* newsletter inline feedback (Shopify customer form posts normally; show state on return) */
  if (location.search.includes('customer_posted=true')) { const ok = $('[data-signup-ok]'); if (ok) ok.hidden = false; }
})();
